import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface ExchangeRate {
  payrollId: string
  currencyToId: string
  currencyFromId: string
  startDate: Date
  endDate: Date
  exchangeRate: number
  secondaryExchangeRate: boolean
}

export async function getExchangeRates(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(origin_currency.name,target_currency.name,exchange_rates.exchange_rate) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by exchange_rates.updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_exchange_rates'],
    fields: [
      'exchange_rates.id',
      'origin_currency.name as origin_currency',
      'target_currency.name as target_currency',
      'exchange_rates.exchange_rate',
      'exchange_rates.start_date',
      'exchange_rates.end_date',
      'exchange_rates.updated_at'
    ],
    join: [
      'INNER JOIN currencies as origin_currency ON exchange_rates.currency_from_id=origin_currency.id',
      'INNER JOIN currencies as target_currency ON exchange_rates.currency_to_id=target_currency.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getExchangeRate(id: string): Promise<ExchangeRate> {
  const data = await getData<any>({
    tables: ['pg_exchange_rates'],
    fields: [
      'id',
      'payroll_id as payrollId',
      'currency_from_id as currencyFromId',
      'currency_to_id as currencyToId',
      "TO_CHAR(start_date, 'yyyy-mm-dd') as startDate",
      "TO_CHAR(end_date, 'yyyy-mm-dd') as endDate",
      'exchange_rate as exchangeRate',
      'secondary_exchange_rate as secondaryExchangeRate',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createExchangeRate(data: ExchangeRate): Promise<boolean> {
  const response: any = await http.post('payroll/exchange-rate', {
    payrollId: data.payrollId,
    currencyToId: data.currencyToId,
    currencyFromId: data.currencyFromId,
    startDate: data.startDate,
    endDate: data.endDate,
    exchangeRate: data.exchangeRate,
    secondaryExchangeRate: data.secondaryExchangeRate,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateExchangeRate(
  data: ExchangeRate,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/exchange-rate/' + id, {
    payrollId: data.payrollId,
    currencyToId: data.currencyToId,
    currencyFromId: data.currencyFromId,
    startDate: data.startDate,
    endDate: data.endDate,
    exchangeRate: data.exchangeRate,
    secondaryExchangeRate: data.secondaryExchangeRate,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteExchangeRate(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/exchange-rate/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
